var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { StyleUpdaterFactory } from './styleUpdater';
import defaultDomService from './domService';
import { WixService } from './wixService';
import { Plugins } from './plugins';
import { defaultPlugins } from './defaultPlugins';
import { defaultReplacers } from './defaultReplacers';
/* tslint:disable:no-invalid-this */
export default {
    styleUpdater: null,
    plugins: new Plugins(),
    init: function (options, domService, wixService) {
        var _this = this;
        if (options === void 0) { options = {}; }
        if (domService === void 0) { domService = defaultDomService; }
        if (wixService === void 0) { wixService = new WixService(window.Wix); }
        Object.keys(defaultPlugins)
            .forEach(function (funcName) { return _this.plugins.addCssFunction(funcName, defaultPlugins[funcName]); });
        Object.keys(defaultReplacers)
            .forEach(function (funcName) { return _this.plugins.addDeclarationReplacer(defaultReplacers[funcName]); });
        var defaultOptions = {};
        defaultOptions.plugins = this.plugins;
        defaultOptions.shouldUseCssVars = domService.isCssVarsSupported() && (wixService.isEditorMode() || wixService.isPreviewMode());
        defaultOptions.shouldApplyCSSFunctions = !wixService.shouldRunAsStandalone();
        options = __assign(__assign({}, defaultOptions), options);
        this.styleUpdater = StyleUpdaterFactory(wixService, domService, options);
        if (wixService.isEditorMode() || wixService.isPreviewMode()) {
            wixService.listenToStyleParamsChange(function () { return _this.styleUpdater.update(true); });
        }
        return this.styleUpdater.update();
    },
    update: function (isRerender) {
        return this.styleUpdater.update(isRerender);
    }
};
//# sourceMappingURL=index.js.map